import {
  createVideoCallContact,
  getVideoCallContact,
  updateVideoCallContact,
  getAdminContacts,
} from '../../../../util/APIUtils';
import { createUniqueUsername, getBase64, HttpsStatus } from '../../../services/utilty';

const manageCallContacts = (data, isEdit) => {
  const response = {
    status: HttpsStatus.OK,
    msg: 'Created successfully!',
  };
  return new Promise(async (resolve) => {
    try {
      let apiResponse = null;
      if (isEdit) {
        apiResponse = await updateVideoCallContact(await getPayload(data, isEdit));
        response.msg = 'Contact updated successfully!';
      } else {
        apiResponse = await createVideoCallContact(await getPayload(data));
        response.msg = 'Contact added successfully!';
      }
      resolve(response);
    } catch (e) {
      console.log('API Error:', e);
      response.msg = 'This email is already in use. Please try a different email.';
      response.status = HttpsStatus.INTERNAL_ERROR;
      resolve(response);
    }
  });
};

const getContactDetails = (userId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getVideoCallContact(userId);
      if (response) {
        resolve({
          id: response.contactId,
          resident: response.residentId,
          firstName: response.firstName,
          lastName: response.lastName,
          relationship: response.relationshipType,
          language: response.preferredLanguage,
          phoneNumber: response.phoneNumber ? formatPhoneNumber(`+1${response.phoneNumber}`) : '',
          email: response.email,
          imageUrl: response.idDocumentUrl,
        });
        return;
      }
      reject('User not found with this ID');
    } catch (error) {
      reject(error);
    }
  });
};

const getContactsList = (request) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getAdminContacts(request);
      if (response) {
        // Return the structured response format
        const structuredResponse = {
          statusCode: 'OK',
          statusMessage: 'Contacts fetched successfully',
          data: {
            content: response || [],
          },
        };
        resolve(structuredResponse);
        return;
      }
      reject('Failed to fetch contacts');
    } catch (error) {
      reject(error);
    }
  });
};

const normalizePhoneNumber = (formattedValue) => {
  if (!formattedValue) return formattedValue;

  // Remove all non-digit characters
  const digits = formattedValue.replace(/[^\d]/g, '');

  // Optionally remove country code if it's always +1
  if (digits.startsWith('1') && digits.length === 11) {
    return digits.slice(1); // Return 10-digit number
  }

  return digits;
};

function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return phoneNumberString;
}

const getPayload = async (data, isEdit) => {
  const payload = {
    person: {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      username: createUniqueUsername(data.firstName, data.lastName),
      locationId: data.locationId,
    },
    contactDetails: {
      phoneNumber: normalizePhoneNumber(data.phoneNumber),
      preferredLanguage: data.language,
      preferredNotificationMethod: '',
    },
    contactRelationshipDetails: {
      relationshipType: data.relationship,
      residentId: data.resident,
    },
  };
  if (data.image) {
    payload['idDocument'] = {
      base64Image: await getBase64(data.image),
    };
  }
  if (isEdit) {
    payload.contactId = data.id;
  }
  return payload;
};

const getJoinedPairs = (object) => {
  return Object.entries(object)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
};


export { getJoinedPairs, manageCallContacts, getContactDetails, getContactsList, formatPhoneNumber };
